'use client'

import { ComponentProps } from 'react'
import { useSearchParams } from 'next/navigation'

import { SpaceCard } from '~/domains/search/components/space-card'

export const DistrictPageSpaceCard = ({
	href,
	...props
}: ComponentProps<typeof SpaceCard>) => {
	const searchParams = useSearchParams()
	const currentSearch = searchParams.toString()

	return (
		<SpaceCard
			href={`${href}${currentSearch ? `?${currentSearch}` : ''}`}
			{...props}
		/>
	)
}
